import ExclamationIcon from 'assets/icons/exclamation-icon.svg';
import styles from './error-message.module.scss';

export const ErrorMessageBox = ({ message }: IProps) => {
	return (
		<div className={styles.message} role="alert">
			<div className={styles.icon}>
				<ExclamationIcon />
			</div>
			<div className={styles.text}>{message}</div>
		</div>
	);
};

export interface IProps {
	message: string;
}

export default ErrorMessageBox;
